import e from "./index.ce.vue2.js";
import o from "./index.ce.vue3.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ r(e, [["styles", [o]]]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/receive-address/index.ce.vue.js
// module id = 1275
// module chunks = 41